import { useState } from "react";
import { LightningIcon, CaretDownIcon, CheckIcon } from "@phosphor-icons/react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator,
} from "./ui/dropdown-menu";
import { PLATFORMS, getTradePlatform, setTradePlatform, buildTradeUrl } from "../lib/trade";
import { useRugLedger } from "../lib/useRugLedger";
import { RugBuyConfirm } from "./RugControls";

export const QuickBuyLink = ({ coin, testid, size = 16 }) => {
  const platform = getTradePlatform();
  const current = PLATFORMS[platform] || PLATFORMS.axiom;
  const url = buildTradeUrl(platform, coin);
  const { rugCountForCreator, isBlockedCreator } = useRugLedger();
  const count = rugCountForCreator(coin.creator);
  const [guard, setGuard] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    if (isBlockedCreator(coin.creator)) {
      e.preventDefault();
      setGuard(true);
    }
  };

  return (
    <>
      <a
        data-testid={testid}
        href={url}
        target="_blank"
        rel="noreferrer"
        onClick={handleClick}
        title={`Buy on ${current.label}`}
        className="inline-flex items-center justify-center p-1.5 text-black bg-neon hover:bg-neon/90 transition-colors"
      >
        <LightningIcon size={size} weight="fill" />
      </a>
      <RugBuyConfirm open={guard} count={count} symbol={coin.symbol} onCancel={() => setGuard(false)} onConfirm={() => { setGuard(false); window.open(url, "_blank"); }} />
    </>
  );
};

export const QuickSellLink = ({ coin, testid, size = 16 }) => {
  const platform = getTradePlatform();
  const current = PLATFORMS[platform] || PLATFORMS.axiom;
  const url = buildTradeUrl(platform, coin);
  return (
    <a
      data-testid={testid}
      href={url}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => e.stopPropagation()}
      title={`Sell / trade on ${current.label} (mirror the sell)`}
      className="inline-flex items-center justify-center p-1.5 text-white bg-danger hover:bg-danger/90 transition-colors"
    >
      <LightningIcon size={size} weight="fill" />
    </a>
  );
};

export const TradeButton = ({ coin, size = "md" }) => {
  const [platform, setPlatform] = useState(getTradePlatform());
  const current = PLATFORMS[platform] || PLATFORMS.axiom;
  const url = buildTradeUrl(platform, coin);
  const pad = size === "sm" ? "px-3 py-1.5 text-xs" : "px-4 py-2.5 text-sm";
  const { rugCountForCreator, isBlockedCreator } = useRugLedger();
  const count = rugCountForCreator(coin.creator);
  const [guard, setGuard] = useState(false);

  const choose = (key) => {
    setPlatform(key);
    setTradePlatform(key);
  };

  const handleBuy = (e) => {
    if (isBlockedCreator(coin.creator)) {
      e.preventDefault();
      setGuard(true);
    }
  };

  return (
    <div className="flex items-stretch">
      <a
        data-testid="trade-buy-btn"
        href={url}
        target="_blank"
        rel="noreferrer"
        onClick={handleBuy}
        className={`flex items-center gap-2 ${pad} bg-neon text-black font-semibold hover:bg-neon/90 transition-colors`}
      >
        <LightningIcon size={16} weight="fill" /> Buy on {current.label}
      </a>
      <RugBuyConfirm open={guard} count={count} symbol={coin.symbol} onCancel={() => setGuard(false)} onConfirm={() => { setGuard(false); window.open(url, "_blank"); }} />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            data-testid="trade-platform-toggle"
            className="flex items-center px-2 bg-neon/80 text-black hover:bg-neon transition-colors border-l border-black/20"
            aria-label="Choose trading platform"
          >
            <CaretDownIcon size={14} weight="bold" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-card border-white/10">
          <DropdownMenuLabel className="text-xs text-muted-foreground">Open coin on</DropdownMenuLabel>
          <DropdownMenuSeparator className="bg-white/10" />
          {Object.entries(PLATFORMS).map(([key, p]) => (
            <DropdownMenuItem
              key={key}
              data-testid={`trade-platform-${key}`}
              onClick={() => choose(key)}
              className="text-sm cursor-pointer flex items-center justify-between"
            >
              {p.label}
              {platform === key && <CheckIcon size={14} className="text-neon" />}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
